import * as React from 'react';

function MailBoxImage() {
	return (
		<div className='mailbox-empty-image'>
			<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 155'>
				<path
					className='cls-3'
					d='M27,115.28a.38.38,0,0,1-.37-.37V96.64a.38.38,0,0,1,.75,0V114.9A.38.38,0,0,1,27,115.28Z'
				/>
				<path className='cls-3' d='M49.42,144.57H26.59v-.37a.39.39,0,0,1,.46-.37H49.42a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M41.63,97H38.39a.38.38,0,0,1,0-.75h3.25a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M49.52,97H43.15a.38.38,0,0,1,0-.75h6.37a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M32.87,97H24.69V90.56H49.62a.38.38,0,1,1,0,.75H25.44v5h7.43a.38.38,0,0,1,0,.75Z'
				/>
				<path className='cls-3' d='M40.66,91.31H36.1V84.86h4.55Zm-3.8-.75h3.05v-5H36.85Z' />
				<path className='cls-3' d='M33,91.31H28.5V84.86H33Zm-3.8-.75H32.3v-5H29.25Z' />
				<path
					className='cls-3'
					d='M49.42,117.94H44.19V105.78h5.13a.38.38,0,0,1,0,.75H44.94v10.66h4.48a.37.37,0,0,1,0,.75Z'
				/>
				<path className='cls-3' d='M49.52,112.23H44.85a.38.38,0,0,1,0-.75h4.67a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M41.61,117.94H34.2V105.78h7.41ZM35,117.19h5.91V106.53H35Z' />
				<path className='cls-3' d='M40.95,112.23H34.86a.38.38,0,0,1,0-.75h6.08a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M49.22,137h-5V124.8h5.54a.37.37,0,0,1,0,.75H44.94v10.66h4.28a.38.38,0,1,1,0,.75Z'
				/>
				<path className='cls-3' d='M49.63,131.25H44.85a.38.38,0,0,1,0-.75h4.78a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M40.67,144.6H30.38V124.77H40.67Zm-9.54-.75h8.79V125.52H31.13Z' />
				<path
					className='cls-3'
					d='M168.19,144H144.39a.38.38,0,0,1,0-.75h23.06V65.87H141.28a.38.38,0,0,1,0-.75h26.91Z'
				/>
				<path className='cls-3' d='M161.91,122.52h-6.33v-8.66h6.33Zm-5.58-.75h4.83v-7.16h-4.83Z' />
				<path className='cls-3' d='M151.44,122.52h-6.33v-8.66h6.33Zm-5.58-.75h4.83v-7.16h-4.83Z' />
				<path className='cls-3' d='M161.91,144h-8.43v-16.8h8.43Zm-7.68-.75h6.93V128h-6.93Z' />
				<path className='cls-3' d='M162.61,86.93h-6.33V78.26h6.33ZM157,86.18h4.83V79H157Z' />
				<path className='cls-3' d='M152.14,86.93h-6.33V78.26h6.33Zm-5.58-.75h4.83V79h-4.83Z' />
				<path className='cls-3' d='M161.91,98.79h-6.33V90.13h6.33ZM156.33,98h4.83V90.88h-4.83Z' />
				<path className='cls-3' d='M151.44,98.79h-6.33V90.13h6.33ZM145.86,98h4.83V90.88h-4.83Z' />
				<path className='cls-3' d='M161.91,110.66h-6.33V102h6.33Zm-5.58-.75h4.83v-7.16h-4.83Z' />
				<path className='cls-3' d='M151.44,110.66h-6.33V102h6.33Zm-5.58-.75h4.83v-7.16h-4.83Z' />
				<path className='cls-3' d='M164,65.87h-3.54V58.14H164Zm-2.79-.75h2V58.89h-2Z' />
				<path className='cls-3' d='M148.28,70.06a.38.38,0,0,1,0-.75l18.84-.1h0a.38.38,0,0,1,0,.75l-18.84.1Z' />
				<path className='cls-3' d='M146.88,70.06h-2.79a.38.38,0,0,1,0-.75h2.79a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M142,70.06h-1.4a.38.38,0,0,1,0-.75H142a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M157.35,72.15a.38.38,0,0,1,0-.75l9.77,0h0a.38.38,0,0,1,0,.75l-9.77,0Z' />
				<path
					className='cls-3'
					d='M95.08,140.82a.38.38,0,0,1-.37-.37v-60H93.12a.38.38,0,1,1,0-.75h2.34v60.72A.38.38,0,0,1,95.08,140.82Z'
				/>
				<path
					className='cls-3'
					d='M51.7,81.31a.38.38,0,0,1-.37-.37V79.72h34a.38.38,0,0,1,0,.75H52.07v.47A.38.38,0,0,1,51.7,81.31Z'
				/>
				<path
					className='cls-3'
					d='M51.7,85.14a.38.38,0,0,1-.37-.37V83.33a.37.37,0,0,1,.75,0v1.44A.38.38,0,0,1,51.7,85.14Z'
				/>
				<path
					className='cls-3'
					d='M94.93,144.88H51.32V87.07a.37.37,0,0,1,.75,0v57.05H94.93a.38.38,0,0,1,0,.75Z'
				/>
				<path
					className='cls-3'
					d='M95.08,141.07a.38.38,0,0,1-.37-.37V80a.38.38,0,0,1,.75,0V140.7A.38.38,0,0,1,95.08,141.07Z'
				/>
				<path className='cls-3' d='M138.82,144.88H95.17a.38.38,0,0,1,0-.75h43.64a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M138.92,141.06a.38.38,0,0,1-.37-.37V83.94a.38.38,0,0,1,.75,0v56.75A.38.38,0,0,1,138.92,141.06Z'
				/>
				<path
					className='cls-3'
					d='M138.92,81.13a.38.38,0,0,1-.37-.37V78.64a.38.38,0,0,1,.75,0v2.12A.38.38,0,0,1,138.92,81.13Z'
				/>
				<path
					className='cls-3'
					d='M95.08,78a.38.38,0,0,1-.37-.37V62.07a.46.46,0,0,1,.46-.46h43.65a.47.47,0,0,1,.46.46V76.52a.38.38,0,0,1-.75,0V62.35H95.46V77.6A.38.38,0,0,1,95.08,78Z'
				/>
				<path className='cls-3' d='M90.17,80.47H87.78a.38.38,0,0,1,0-.75h2.39a.38.38,0,1,1,0,.75Z' />
				<path
					className='cls-3'
					d='M95.7,80.47H92.24a.38.38,0,0,1,0-.75H95.6V78.23H51.18v1.49H85.23a.38.38,0,0,1,0,.75H51.08a.65.65,0,0,1-.65-.65V78.13a.65.65,0,0,1,.65-.65H95.7a.65.65,0,0,1,.65.65v1.68A.65.65,0,0,1,95.7,80.47Z'
				/>
				<path
					className='cls-3'
					d='M93.58,78.23H53.2l14.49-16h9a.38.38,0,0,1,0,.75H68L54.89,77.48h37L78.7,63a.37.37,0,0,1-.18-.31.35.35,0,0,1,.34-.37H79l.18.12Z'
				/>
				<path
					className='cls-3'
					d='M80.38,63H79.09a.38.38,0,0,1,0-.75h1.19V61H66.5v1.26H76.3a.38.38,0,1,1,0,.75H66.4a.65.65,0,0,1-.65-.65V60.91a.65.65,0,0,1,.65-.65h14a.65.65,0,0,1,.65.65v1.46A.65.65,0,0,1,80.38,63Z'
				/>
				<path
					className='cls-3'
					d='M70,61H68.75a.65.65,0,0,1-.65-.65v-2.8a.65.65,0,0,1,.65-.65h.46a.38.38,0,0,1,0,.75h-.36v2.6h1V57.63a.37.37,0,0,1,.26-.7.65.65,0,0,1,.49.63v2.8A.65.65,0,0,1,70,61Z'
				/>
				<path className='cls-3' d='M90.7,76H64.2a.38.38,0,0,1,0-.75H90.7a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M85.43,70.34H78.85a.38.38,0,1,1,0-.75h6.58a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M71.59,67.51H63.78a.38.38,0,0,1,0-.75h7.81a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M88.37,73.54H72.51a.38.38,0,1,1,0-.75H88.37a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M69.31,73.53H67.24a.38.38,0,0,1,0-.75h2.08a.38.38,0,1,1,0,.75Z' />
				<path
					className='cls-3'
					d='M90.82,95H83.57a.78.78,0,0,1-.78-.78V84.52a.78.78,0,0,1,.78-.77h7.25a.78.78,0,0,1,.77.77v9.71A.78.78,0,0,1,90.82,95ZM83.57,84.49l0,9.74,0,0h7.25l0-9.74Z'
				/>
				<path
					className='cls-3'
					d='M92,95.9H82.45a.66.66,0,0,1-.65-.65v-.34a.66.66,0,0,1,.65-.65H92a.66.66,0,0,1,.65.65v.34A.66.66,0,0,1,92,95.9Zm-9.41-.75h9.31V95H82.54Z'
				/>
				<path
					className='cls-3'
					d='M76.51,95H69.26a.78.78,0,0,1-.77-.78V84.52a.78.78,0,0,1,.77-.77h7.25a.78.78,0,0,1,.77.77v9.71A.78.78,0,0,1,76.51,95ZM69.26,84.49l0,9.74,0,0h7.25l0-9.74Z'
				/>
				<path
					className='cls-3'
					d='M77.64,95.9H68.13a.66.66,0,0,1-.65-.65v-.34a.66.66,0,0,1,.65-.65h9.51a.66.66,0,0,1,.65.65v.34A.66.66,0,0,1,77.64,95.9Zm-9.41-.75h9.31V95H68.23Z'
				/>
				<path
					className='cls-3'
					d='M62.2,95H54.95a.78.78,0,0,1-.78-.78V84.52a.78.78,0,0,1,.78-.77H62.2a.78.78,0,0,1,.77.77v9.71A.78.78,0,0,1,62.2,95ZM54.95,84.49l0,9.74,0,0H62.2l0-9.74Z'
				/>
				<path
					className='cls-3'
					d='M63.33,95.9H53.82a.66.66,0,0,1-.65-.65v-.34a.66.66,0,0,1,.65-.65h9.51a.66.66,0,0,1,.65.65v.34A.66.66,0,0,1,63.33,95.9Zm-9.41-.75h9.31V95H53.92Z'
				/>
				<path
					className='cls-3'
					d='M90.82,115.35H83.57a.78.78,0,0,1-.78-.77v-9.71a.78.78,0,0,1,.78-.78h7.25a.78.78,0,0,1,.77.78v9.71A.78.78,0,0,1,90.82,115.35Zm-7.25-10.51,0,9.74,0,0h7.25l0-9.74Z'
				/>
				<path
					className='cls-3'
					d='M92,116.25H82.45a.65.65,0,0,1-.65-.65v-.34a.66.66,0,0,1,.65-.65H92a.66.66,0,0,1,.65.65v.34A.65.65,0,0,1,92,116.25Zm-9.41-.75h9.31v-.14H82.54Z'
				/>
				<path
					className='cls-3'
					d='M76.51,115.35H69.26a.78.78,0,0,1-.77-.77v-9.71a.78.78,0,0,1,.77-.78h7.25a.78.78,0,0,1,.77.78v9.71A.78.78,0,0,1,76.51,115.35Zm-7.25-10.51,0,9.74,0,0h7.25l0-9.74Z'
				/>
				<path
					className='cls-3'
					d='M77.64,116.25H68.13a.65.65,0,0,1-.65-.65v-.34a.66.66,0,0,1,.65-.65h9.51a.66.66,0,0,1,.65.65v.34A.65.65,0,0,1,77.64,116.25Zm-9.41-.75h9.31v-.14H68.23Z'
				/>
				<path
					className='cls-3'
					d='M62.2,115.35H54.95a.78.78,0,0,1-.78-.77v-9.71a.78.78,0,0,1,.78-.78H62.2a.78.78,0,0,1,.77.78v9.71A.78.78,0,0,1,62.2,115.35Zm-7.25-10.51,0,9.74,0,0H62.2l0-9.74Z'
				/>
				<path
					className='cls-3'
					d='M63.33,116.25H53.82a.65.65,0,0,1-.65-.65v-.34a.66.66,0,0,1,.65-.65h9.51a.66.66,0,0,1,.65.65v.34A.65.65,0,0,1,63.33,116.25Zm-9.41-.75h9.31v-.14H53.92Z'
				/>
				<path
					className='cls-3'
					d='M76.51,138.84H69.26a.78.78,0,0,1-.77-.78v-9.71a.78.78,0,0,1,.77-.77h7.25a.78.78,0,0,1,.77.77v9.71A.78.78,0,0,1,76.51,138.84Zm-7.25-10.51,0,9.74,0,0h7.25l0-9.74Z'
				/>
				<path
					className='cls-3'
					d='M77.64,139.73H68.13a.66.66,0,0,1-.65-.65v-.34a.66.66,0,0,1,.65-.65h9.51a.66.66,0,0,1,.65.65v.34A.66.66,0,0,1,77.64,139.73ZM68.23,139h9.31v-.14H68.23Z'
				/>
				<path
					className='cls-3'
					d='M62.2,138.84H54.95a.78.78,0,0,1-.78-.78v-9.71a.78.78,0,0,1,.78-.77H62.2a.78.78,0,0,1,.77.77v9.71A.78.78,0,0,1,62.2,138.84Zm-7.25-10.51,0,9.74,0,0H62.2l0-9.74Z'
				/>
				<path
					className='cls-3'
					d='M63.33,139.73H53.82a.66.66,0,0,1-.65-.65v-.34a.66.66,0,0,1,.65-.65h9.51a.66.66,0,0,1,.65.65v.34A.66.66,0,0,1,63.33,139.73ZM53.92,139h9.31v-.14H53.92Z'
				/>
				<path
					className='cls-3'
					d='M98.88,144.88H75.75a.78.78,0,0,1-.77-.78v-1a.78.78,0,0,1,.77-.78H98.88a.78.78,0,0,1,.77.78v1A.78.78,0,0,1,98.88,144.88Zm-23.13-1.79,0,1,0,0H98.88l0-1Z'
				/>
				<path
					className='cls-3'
					d='M96.3,143.09h-18a.78.78,0,0,1-.77-.78v-1a.78.78,0,0,1,.77-.78h18a.78.78,0,0,1,.77.78v1A.78.78,0,0,1,96.3,143.09Zm-18-1.79,0,1,0,0h18l0-1Z'
				/>
				<path
					className='cls-3'
					d='M91.77,141.3H83a.78.78,0,0,1-.77-.78V124.77A.78.78,0,0,1,83,124h8.82a.78.78,0,0,1,.77.77v15.75A.78.78,0,0,1,91.77,141.3ZM83,124.75l0,15.77,0,0h8.82l0-15.77Z'
				/>
				<path className='cls-3' d='M84.35,134.59a.38.38,0,0,1,0-.75h7.83a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M89.08,135.68h0l-6.52-.08v-.75l6.52.08a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M90.83,135.71H90a.38.38,0,0,1,0-.75h.85a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M142.93,144.88H119.8a.78.78,0,0,1-.78-.78v-1a.78.78,0,0,1,.78-.78h23.13a.78.78,0,0,1,.78.78v1A.78.78,0,0,1,142.93,144.88Zm-23.13-1.79,0,1,23.15,0a0,0,0,0,0,0,0v-1Z'
				/>
				<path
					className='cls-3'
					d='M140.36,143.09h-18a.78.78,0,0,1-.78-.78v-1a.78.78,0,0,1,.78-.78h18a.78.78,0,0,1,.77.78v1A.78.78,0,0,1,140.36,143.09Zm-18-1.79,0,1,18,0a0,0,0,0,0,0,0v-1Z'
				/>
				<path
					className='cls-3'
					d='M135.72,141.3H126.9a.78.78,0,0,1-.78-.78V124.77a.78.78,0,0,1,.78-.77h8.82a.78.78,0,0,1,.77.77v15.75A.78.78,0,0,1,135.72,141.3Zm-8.82-16.55,0,15.77,8.84,0a0,0,0,0,0,0,0V124.77Z'
				/>
				<path className='cls-3' d='M134.33,134.59H126.5a.38.38,0,1,1,0-.75h7.83a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M129.6,135.68a.38.38,0,0,1,0-.75l6.52-.08v.75l-6.52.08Z' />
				<path
					className='cls-3'
					d='M127.84,135.71a.38.38,0,0,1,0-.75h.85a.35.35,0,0,1,.38.37.38.38,0,0,1-.37.38h-.85Z'
				/>
				<path
					className='cls-3'
					d='M134.1,78.31h-7a.78.78,0,0,1-.78-.77V67.15a.78.78,0,0,1,.78-.78h7a.78.78,0,0,1,.77.78V77.53A.78.78,0,0,1,134.1,78.31Zm-7-11.18,0,10.41,0,0h7l0-10.41Z'
				/>
				<path
					className='cls-3'
					d='M134.31,79.35h-7.45a.68.68,0,0,1-.68-.68v-.36a.68.68,0,0,1,.68-.68h7.45a.68.68,0,0,1,.68.68v.36A.68.68,0,0,1,134.31,79.35Zm-7.37-.75h7.3v-.21h-7.3Z'
				/>
				<path
					className='cls-3'
					d='M120.23,78.31h-7a.78.78,0,0,1-.77-.77V67.15a.78.78,0,0,1,.77-.78h7a.78.78,0,0,1,.78.78V77.53A.78.78,0,0,1,120.23,78.31Zm-7-11.18,0,10.41,0,0h7l0-10.41Z'
				/>
				<path
					className='cls-3'
					d='M120.44,79.35H113a.68.68,0,0,1-.68-.68v-.36a.68.68,0,0,1,.68-.68h7.45a.68.68,0,0,1,.68.68v.36A.68.68,0,0,1,120.44,79.35Zm-7.37-.75h7.3v-.21h-7.3Z'
				/>
				<path
					className='cls-3'
					d='M106.37,78.31h-7a.78.78,0,0,1-.77-.77V67.15a.78.78,0,0,1,.77-.78h7a.78.78,0,0,1,.78.78V77.53A.78.78,0,0,1,106.37,78.31Zm-7-11.18,0,10.41,0,0h7l0-10.41Z'
				/>
				<path
					className='cls-3'
					d='M106.58,79.35H99.13a.68.68,0,0,1-.68-.68v-.36a.68.68,0,0,1,.68-.68h7.45a.68.68,0,0,1,.68.68v.36A.68.68,0,0,1,106.58,79.35ZM99.2,78.6h7.3v-.21H99.2Z'
				/>
				<path
					className='cls-3'
					d='M134.1,94.86h-7a.78.78,0,0,1-.78-.78V83.7a.78.78,0,0,1,.78-.78h7a.78.78,0,0,1,.77.78V94.08A.78.78,0,0,1,134.1,94.86Zm-7-11.18,0,10.41,0,0h7l0-10.41Z'
				/>
				<path
					className='cls-3'
					d='M134.31,95.9h-7.45a.68.68,0,0,1-.68-.68v-.36a.68.68,0,0,1,.68-.68h7.45a.68.68,0,0,1,.68.68v.36A.68.68,0,0,1,134.31,95.9Zm-7.37-.75h7.3v-.21h-7.3Z'
				/>
				<path
					className='cls-3'
					d='M120.23,94.86h-7a.78.78,0,0,1-.77-.78V83.7a.78.78,0,0,1,.77-.78h7a.78.78,0,0,1,.78.78V94.08A.78.78,0,0,1,120.23,94.86Zm-7-11.18,0,10.41,0,0h7l0-10.41Z'
				/>
				<path
					className='cls-3'
					d='M120.44,95.9H113a.68.68,0,0,1-.68-.68v-.36a.68.68,0,0,1,.68-.68h7.45a.68.68,0,0,1,.68.68v.36A.68.68,0,0,1,120.44,95.9Zm-7.37-.75h7.3v-.21h-7.3Z'
				/>
				<path
					className='cls-3'
					d='M106.37,94.86h-7a.78.78,0,0,1-.77-.78V83.7a.78.78,0,0,1,.77-.78h7a.78.78,0,0,1,.78.78V94.08A.78.78,0,0,1,106.37,94.86Zm-7-11.18,0,10.41,0,0h7l0-10.41Z'
				/>
				<path
					className='cls-3'
					d='M106.58,95.9H99.13a.68.68,0,0,1-.68-.68v-.36a.68.68,0,0,1,.68-.68h7.45a.68.68,0,0,1,.68.68v.36A.68.68,0,0,1,106.58,95.9Zm-7.37-.75h7.3v-.21H99.2Z'
				/>
				<path
					className='cls-3'
					d='M134.1,115.43h-7a.78.78,0,0,1-.78-.78V104.27a.78.78,0,0,1,.78-.77h7a.78.78,0,0,1,.77.77v10.38A.78.78,0,0,1,134.1,115.43Zm-7-11.18,0,10.41,0,0h7l0-10.41Z'
				/>
				<path
					className='cls-3'
					d='M134.31,116.47h-7.45a.68.68,0,0,1-.68-.68v-.36a.68.68,0,0,1,.68-.68h7.45a.68.68,0,0,1,.68.68v.36A.68.68,0,0,1,134.31,116.47Zm-7.37-.75h7.3v-.21h-7.3Z'
				/>
				<path
					className='cls-3'
					d='M120.23,115.43h-7a.78.78,0,0,1-.77-.78V104.27a.78.78,0,0,1,.77-.77h7a.78.78,0,0,1,.78.77v10.38A.78.78,0,0,1,120.23,115.43Zm-7-11.18,0,10.41,0,0h7l0-10.41Z'
				/>
				<path
					className='cls-3'
					d='M120.44,116.47H113a.68.68,0,0,1-.68-.68v-.36a.68.68,0,0,1,.68-.68h7.45a.68.68,0,0,1,.68.68v.36A.68.68,0,0,1,120.44,116.47Zm-7.37-.75h7.3v-.21h-7.3Z'
				/>
				<path
					className='cls-3'
					d='M106.37,115.43h-7a.78.78,0,0,1-.77-.78V104.27a.78.78,0,0,1,.77-.77h7a.78.78,0,0,1,.78.77v10.38A.78.78,0,0,1,106.37,115.43Zm-7-11.18,0,10.41,0,0h7l0-10.41Z'
				/>
				<path
					className='cls-3'
					d='M106.58,116.47H99.13a.68.68,0,0,1-.68-.68v-.36a.68.68,0,0,1,.68-.68h7.45a.68.68,0,0,1,.68.68v.36A.68.68,0,0,1,106.58,116.47Zm-7.37-.75h7.3v-.21H99.2Z'
				/>
				<path
					className='cls-3'
					d='M120.23,138.69h-7a.78.78,0,0,1-.77-.77V127.53a.78.78,0,0,1,.77-.78h7a.78.78,0,0,1,.78.78v10.38A.78.78,0,0,1,120.23,138.69Zm-7-11.18,0,10.41,0,0h7l0-10.41Z'
				/>
				<path
					className='cls-3'
					d='M120.44,139.73H113a.68.68,0,0,1-.68-.68v-.36A.68.68,0,0,1,113,138h7.45a.68.68,0,0,1,.68.68v.36A.68.68,0,0,1,120.44,139.73Zm-7.37-.75h7.3v-.21h-7.3Z'
				/>
				<path
					className='cls-3'
					d='M106.37,138.69h-7a.78.78,0,0,1-.77-.77V127.53a.78.78,0,0,1,.77-.78h7a.78.78,0,0,1,.78.78v10.38A.78.78,0,0,1,106.37,138.69Zm-7-11.18,0,10.41,0,0h7l0-10.41Z'
				/>
				<path
					className='cls-3'
					d='M106.58,139.73H99.13a.68.68,0,0,1-.68-.68v-.36a.68.68,0,0,1,.68-.68h7.45a.68.68,0,0,1,.68.68v.36A.68.68,0,0,1,106.58,139.73ZM99.2,139h7.3v-.21H99.2Z'
				/>
				<path
					className='cls-3'
					d='M139.7,62.35H94.3a.49.49,0,0,1-.49-.49V59.63a.49.49,0,0,1,.49-.49h41.49a.37.37,0,0,1,0,.75H94.56V61.6h44.87V59.89h-1.22a.38.38,0,0,1,0-.75h1.48a.49.49,0,0,1,.49.49v2.24A.49.49,0,0,1,139.7,62.35Z'
				/>
				<path className='cls-3' d='M133.44,59.89H101.38v-3.7h32.06Zm-31.31-.75h30.56v-2.2H102.13Z' />
				<path
					className='cls-3'
					d='M134.78,56.81H100V54.5h8.86a.38.38,0,0,1,0,.75h-8.11v.82H134v-.82h-23.6a.38.38,0,1,1,0-.75h24.35Z'
				/>
				<path className='cls-3' d='M138.92,120.85H115.77a.38.38,0,0,1,0-.75h23.14a.37.37,0,0,1,0,.75Z' />
				<path className='cls-3' d='M112.36,120.85H101.8a.38.38,0,0,1,0-.75h10.56a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M99.54,120.85H96.9a.38.38,0,0,1,0-.75h2.64a.37.37,0,0,1,0,.75Z' />
				<path className='cls-3' d='M93.8,120.85H78.89a.38.38,0,0,1,0-.75H93.8a.37.37,0,0,1,0,.75Z' />
				<path className='cls-3' d='M75.86,120.85H73a.37.37,0,0,1,0-.75h2.87a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M70,120.85H51.7a.38.38,0,0,1,0-.75H70a.37.37,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M136,100a.38.38,0,0,1,0-.75h2.85a.39.39,0,0,1,.38.37.38.38,0,0,1-.37.38H136Z'
				/>
				<path
					className='cls-3'
					d='M110.65,100.07a.38.38,0,0,1,0-.75l23.84-.11a.39.39,0,0,1,.38.37.38.38,0,0,1-.37.38l-23.84.11Z'
				/>
				<path className='cls-3' d='M101.1,100.11a.38.38,0,0,1,0-.75l5.28,0h0a.38.38,0,0,1,0,.75l-5.28,0Z' />
				<path className='cls-3' d='M74.54,100.23a.38.38,0,0,1,0-.75l18.4-.08h0a.38.38,0,0,1,0,.75l-18.4.08Z' />
				<path className='cls-3' d='M71.13,100.25a.38.38,0,0,1,0-.75h1.71a.38.38,0,0,1,0,.75H71.13Z' />
				<path className='cls-3' d='M58.16,100.3a.38.38,0,0,1,0-.75L70,99.5h0a.38.38,0,0,1,0,.75l-11.8.05Z' />
				<path className='cls-3' d='M133.37,55.28h-4.09V51.19h4.09ZM130,54.53h2.59V51.94H130Z' />
				<path className='cls-3' d='M129.06,55.28H125V48.68h4.09Zm-3.34-.75h2.59V49.43h-2.59Z' />
				<path className='cls-3' d='M124.75,55.28h-4.09V51.19h4.09Zm-3.34-.75H124V51.94h-2.59Z' />
				<path
					className='cls-3'
					d='M131.33,51.94a.38.38,0,0,1-.37-.37V48.5a.38.38,0,0,1,.75,0v3.06A.38.38,0,0,1,131.33,51.94Z'
				/>
				<path className='cls-3' d='M183.19,143.74H168a.37.37,0,0,1,0-.75h14.46V100.75a.38.38,0,1,1,.75,0Z' />
				<path className='cls-3' d='M172.58,101.12h-2.91a.37.37,0,0,1,0-.75h2.91a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M169,101.12h-1.19a.37.37,0,0,1,0-.75H169a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M184.89,101.12h-7.37a.37.37,0,0,1,0-.75h6.62V96H167.79a.38.38,0,0,1,0-.75h17.1Z'
				/>
				<path className='cls-3' d='M174.66,96H170.5V90.14h4.16Zm-3.41-.75h2.66V90.89h-2.66Z' />
				<path className='cls-3' d='M181.48,96h-4.16V90.14h4.16Zm-3.41-.75h2.66V90.89h-2.66Z' />
				<path className='cls-3' d='M176.37,119.87h-6.72v-11h6.72Zm-6-.75h5.22v-9.48H170.4Z' />
				<path className='cls-3' d='M175.74,114.76h-5.45a.38.38,0,1,1,0-.75h5.45a.38.38,0,1,1,0,.75Z' />
				<path className='cls-3' d='M179.79,143.76h-9.3V125.92h9.3Zm-8.55-.75H179V126.67h-7.8Z' />
				<path
					className='cls-3'
					d='M25.7,144.52h-4v-.86a1.18,1.18,0,0,1,1.18-1.18h1.61a1.18,1.18,0,0,1,1.18,1.18Zm-3.21-.75h2.46v-.11a.43.43,0,0,0-.43-.43H22.91a.43.43,0,0,0-.43.43Z'
				/>
				<path
					className='cls-3'
					d='M24.29,143.24H23.14a.6.6,0,0,1-.6-.6v-3.12a.88.88,0,0,1,.88-.87H24a.88.88,0,0,1,.88.88v3.12A.6.6,0,0,1,24.29,143.24Zm-1-.75h.85v-3a.13.13,0,0,0-.13-.12h-.6a.13.13,0,0,0-.13.13Z'
				/>
				<path
					className='cls-3'
					d='M23.72,139.39a.38.38,0,0,1-.37-.37V121a.37.37,0,0,1,.75,0v18A.38.38,0,0,1,23.72,139.39Z'
				/>
				<path
					className='cls-3'
					d='M23.73,127.45h-.07a.38.38,0,0,1-.29-.44,1.68,1.68,0,0,1,.7-1,1.6,1.6,0,0,1,1.29-.15,2.61,2.61,0,0,0,1.95-.27,3.14,3.14,0,0,0,1.13-1.7.37.37,0,1,1,.73.18,3.84,3.84,0,0,1-1.44,2.15,3.36,3.36,0,0,1-2.54.37.89.89,0,0,0-.7.06,1,1,0,0,0-.36.54A.38.38,0,0,1,23.73,127.45Z'
				/>
				<path
					className='cls-3'
					d='M23.7,127.45a.37.37,0,0,1-.37-.3,1,1,0,0,0-.37-.55.9.9,0,0,0-.7-.06,3.33,3.33,0,0,1-2.54-.37A3.83,3.83,0,0,1,18.29,124a.38.38,0,0,1,.27-.46.38.38,0,0,1,.45.27,3.13,3.13,0,0,0,1.13,1.7,2.58,2.58,0,0,0,1.94.27,1.6,1.6,0,0,1,1.29.15,1.68,1.68,0,0,1,.7,1,.38.38,0,0,1-.29.44Z'
				/>
				<path
					className='cls-3'
					d='M28.86,124.31A2.14,2.14,0,1,1,31,122.17,2.14,2.14,0,0,1,28.86,124.31Zm0-3.53a1.39,1.39,0,1,0,1.39,1.39A1.39,1.39,0,0,0,28.86,120.78Z'
				/>
				<path className='cls-3' d='M31.27,122.38H26.45a.38.38,0,0,1,0-.75h4.81a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M28.86,120.62a.38.38,0,0,1-.37-.37v-.48a.37.37,0,1,1,.75,0v.48A.38.38,0,0,1,28.86,120.62Z'
				/>
				<path
					className='cls-3'
					d='M18.59,124.31a2.14,2.14,0,1,1,2.14-2.14A2.14,2.14,0,0,1,18.59,124.31Zm0-3.53A1.39,1.39,0,1,0,20,122.17,1.39,1.39,0,0,0,18.59,120.78Z'
				/>
				<path className='cls-3' d='M21,122.38H16.19a.38.38,0,0,1,0-.75H21a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M18.59,120.62a.38.38,0,0,1-.37-.37v-.48a.38.38,0,0,1,.75,0v.48A.38.38,0,0,1,18.59,120.62Z'
				/>
				<path
					className='cls-3'
					d='M23.72,121.42a2.14,2.14,0,1,1,2.14-2.14A2.14,2.14,0,0,1,23.72,121.42Zm0-3.53a1.39,1.39,0,1,0,1.39,1.39A1.39,1.39,0,0,0,23.72,117.89Z'
				/>
				<path className='cls-3' d='M26.12,119.5H21.31a.38.38,0,1,1,0-.75h4.81a.38.38,0,1,1,0,.75Z' />
				<path
					className='cls-3'
					d='M23.72,117.73a.38.38,0,0,1-.37-.37v-.48a.38.38,0,0,1,.75,0v.48A.38.38,0,0,1,23.72,117.73Z'
				/>
				<rect className='cls-4' x='120.44' y='75.68' width='28.28' height='52.38' rx='0.2' ry='0.2' />
				<rect className='cls-5' x='127.77' y='81.45' width='13.62' height='4.19' rx='1' ry='1' />
				<rect className='cls-5' x='118.34' y='72.75' width='32.47' height='3.14' rx='0.2' ry='0.2' />
				<path
					className='cls-4'
					d='M117.29,69.6h34.57a0,0,0,0,1,0,0v2.94a.2.2,0,0,1-.2.2H117.49a.2.2,0,0,1-.2-.2V69.6A0,0,0,0,1,117.29,69.6Z'
				/>
				<path className='cls-5' d='M151.86,68.78a36,36,0,0,0-34.57,0v.82h34.57Z' />
				<rect className='cls-6' x='117.82' y='127.86' width='33.52' height='16.28' rx='2' ry='2' />
				<path
					className='cls-7'
					d='M119.39,134.52a.38.38,0,0,1-.37-.37v-4.57h17.2a.38.38,0,0,1,0,.75H119.76v3.82A.38.38,0,0,1,119.39,134.52Z'
				/>
				<path className='cls-7' d='M140.34,130.33h-1.67a.38.38,0,0,1,0-.75h1.67a.38.38,0,0,1,0,.75Z' />
				<path className='cls-6' d='M134.24,83.92h-4.83a.38.38,0,0,1,0-.75h4.83a.38.38,0,0,1,0,.75Z' />
				<path className='cls-6' d='M138.25,83.92h-1.76a.38.38,0,0,1,0-.75h1.76a.38.38,0,0,1,0,.75Z' />
				<rect className='cls-8' x='127.77' y='92.97' width='13.62' height='16.76' rx='1' ry='1' />
				<path className='cls-6' d='M133.83,96.49h-4a.38.38,0,0,1,0-.75h4a.38.38,0,0,1,0,.75Z' />
				<path className='cls-6' d='M135.52,99.11h-5.66a.38.38,0,0,1,0-.75h5.66a.38.38,0,0,1,0,.75Z' />
				<path className='cls-6' d='M139.29,99.11h-1.52a.38.38,0,0,1,0-.75h1.52a.38.38,0,0,1,0,.75Z' />
				<path className='cls-6' d='M138.25,101.72h-8.38a.38.38,0,0,1,0-.75h8.38a.37.37,0,0,1,0,.75Z' />
				<path
					className='cls-9'
					d='M148,108.8a.38.38,0,0,1-.37-.37v-1.77a.38.38,0,0,1,.75,0v1.77A.38.38,0,0,1,148,108.8Z'
				/>
				<path
					className='cls-9'
					d='M147.9,129.17H119.8a.47.47,0,0,1-.47-.47V76.51a.47.47,0,0,1,.47-.47h24.84a.38.38,0,0,1,0,.75H120.08v51.63h27.53V110.85a.38.38,0,0,1,.75,0V128.7A.47.47,0,0,1,147.9,129.17Z'
				/>
				<path
					className='cls-9'
					d='M148,104.61a.38.38,0,0,1-.37-.37V76.79h-.74a.38.38,0,0,1,0-.75h1a.47.47,0,0,1,.47.47v27.73A.38.38,0,0,1,148,104.61Zm-.09-27.82h0Z'
				/>
				<path
					className='cls-9'
					d='M150,76.78h-3.47a.38.38,0,0,1,0-.75h3.19V73.63H118V76h26.19a.38.38,0,0,1,0,.75H117.7a.47.47,0,0,1-.47-.47v-3a.47.47,0,0,1,.47-.47H150a.47.47,0,0,1,.47.47v3A.47.47,0,0,1,150,76.78Z'
				/>
				<path
					className='cls-9'
					d='M150.93,73.63H116.76a.58.58,0,0,1-.58-.58V69.74h35.32v3.32A.58.58,0,0,1,150.93,73.63Zm-34-.75h33.82V70.49H116.94Z'
				/>
				<path
					className='cls-9'
					d='M151.51,70.49H116.19V69.07l.2-.11a36.4,36.4,0,0,1,24.86-3.7.38.38,0,0,1,.29.44.38.38,0,0,1-.44.29,35.65,35.65,0,0,0-24.15,3.52v.22h33.82v-.22a36.39,36.39,0,0,0-7.28-2.94.38.38,0,1,1,.2-.72A37.19,37.19,0,0,1,151.31,69l.2.11Z'
				/>
				<path
					className='cls-9'
					d='M149.88,144.6H117.82a1.11,1.11,0,0,1-1.11-1.11V129.68a1.11,1.11,0,0,1,1.11-1.11h32.06a1.11,1.11,0,0,1,1.11,1.11v13.81A1.11,1.11,0,0,1,149.88,144.6Zm-32.06-15.28a.36.36,0,0,0-.36.36v13.81a.36.36,0,0,0,.36.36h32.06a.36.36,0,0,0,.36-.36V129.68a.36.36,0,0,0-.36-.36Z'
				/>
				<path
					className='cls-9'
					d='M118.66,135.61a.38.38,0,0,1-.37-.37v-4.56h17.2a.38.38,0,0,1,0,.75H119v3.81A.38.38,0,0,1,118.66,135.61Z'
				/>
				<path className='cls-9' d='M139.61,131.42h-1.67a.38.38,0,0,1,0-.75h1.67a.38.38,0,0,1,0,.75Z' />
				<path className='cls-9' d='M133.51,84.65h-4.83a.38.38,0,0,1,0-.75h4.83a.38.38,0,0,1,0,.75Z' />
				<path className='cls-9' d='M137.52,84.65h-1.76a.38.38,0,0,1,0-.75h1.76a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-9'
					d='M140.46,86.74H127.24a.58.58,0,0,1-.58-.58V82.38a.58.58,0,0,1,.58-.58h13.22a.58.58,0,0,1,.58.58v3.79A.58.58,0,0,1,140.46,86.74Zm-13-.75h12.87V82.55H127.42Z'
				/>
				<path
					className='cls-9'
					d='M140.46,110.83H127.24a.58.58,0,0,1-.58-.58V93.9a.58.58,0,0,1,.58-.58h13.22a.58.58,0,0,1,.58.58v16.36A.58.58,0,0,1,140.46,110.83Zm-13-.75h12.87v-16H127.42Z'
				/>
				<path className='cls-9' d='M133.11,97.22h-4a.38.38,0,0,1,0-.75h4a.38.38,0,0,1,0,.75Z' />
				<path className='cls-9' d='M134.79,99.83h-5.66a.38.38,0,0,1,0-.75h5.66a.38.38,0,0,1,0,.75Z' />
				<path className='cls-9' d='M138.56,99.83H137a.38.38,0,0,1,0-.75h1.52a.38.38,0,0,1,0,.75Z' />
				<path className='cls-9' d='M137.52,102.45h-8.38a.38.38,0,0,1,0-.75h8.38a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-10'
					d='M112.84,143.94c-.17-12.51-4.76-17.29-5.49-18a0,0,0,0,0,0,0c2.42,4.39,2.55,15.61,2.54,18,0,0,0,0,0,0-.8-8.07-4.58-9.58-5.11-9.75,0,0,0,0,0,0,2.74,3.73,2,10.19,2,10.19H119s-1.29-7,3.48-10.2c0,0,0,0,0,0-.68,0-5.94.38-6.63,10.24,0,0,.74-15.64,3.49-21.32a0,0,0,0,0,0,0c-.75.66-6.26,6.06-6.43,20.7'
				/>
				<path
					className='cls-9'
					d='M106,144.88h0a.38.38,0,0,1-.33-.41c0-.06.69-6.35-1.94-9.92l-.16-.22.32-.47.28.08c.61.2,3.16,1.28,4.57,5.9-.19-4.35-.75-10.65-2.4-13.64l-.15-.28.51-.43.26.23c.9.84,5.43,5.71,5.61,18.24a.38.38,0,0,1-.75,0c-.12-8.56-2.35-13.47-3.91-15.87,1.6,5.28,1.68,14,1.68,16v.36l-.73.05-.06-.38c-.54-5.47-2.47-7.83-3.74-8.8,2,3.81,1.39,9,1.36,9.28A.38.38,0,0,1,106,144.88Z'
				/>
				<path
					className='cls-9'
					d='M118.26,144.88a.38.38,0,0,1-.37-.31c0-.27-1.08-6.14,2.5-9.65-1.71.64-4.43,2.75-4.92,9.61l-.75,0c0-.58.64-13,2.78-19.58-1.83,2.46-4.89,8.17-5,19a.38.38,0,0,1-.37.37h0a.38.38,0,0,1-.37-.38c.18-14.88,5.91-20.39,6.56-21l.23-.2.52.37-.13.31c-1.64,3.38-2.56,10.45-3,15.49,1.9-4.74,5.34-4.95,5.83-5H122l.19.55-.25.18c-4.51,3-3.32,9.75-3.31,9.82a.38.38,0,0,1-.3.44Z'
				/>
				<path className='cls-12' d='M198.63,144.87H1.37a.37.37,0,1,1,0-.74H198.63a.37.37,0,0,1,0,.74Z' />
			</svg>
		</div>
	);
}

export { MailBoxImage };
